// extracted by mini-css-extract-plugin
export default {"container":"PaymentMethodHistoryDialog_container__ZAW8O","message":"PaymentMethodHistoryDialog_message__Mc0K4","tableWrapper":"PaymentMethodHistoryDialog_tableWrapper__zA793"};